/**
 * @generated SignedSource<<494f7741afdff4e6253104791a3cfb26>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type sectionStyleStoryCardCarouselWidgetQuery$variables = Record<PropertyKey, never>;
export type sectionStyleStoryCardCarouselWidgetQuery$data = {
  readonly " $fragmentSpreads": FragmentRefs<"displayStoryCardCarouselWidgetQuery">;
};
export type sectionStyleStoryCardCarouselWidgetQuery = {
  response: sectionStyleStoryCardCarouselWidgetQuery$data;
  variables: sectionStyleStoryCardCarouselWidgetQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "kind": "Literal",
    "name": "filter",
    "value": {
      "entityId": "1070"
    }
  }
],
v1 = {
  "kind": "Literal",
  "name": "exclude",
  "value": {
    "types": "VIDEO"
  }
},
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "__typename",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "publishedDate",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "entityId",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "cursor",
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "concreteType": "PageInfo",
  "kind": "LinkedField",
  "name": "pageInfo",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "endCursor",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "hasNextPage",
      "storageKey": null
    }
  ],
  "storageKey": null
},
v7 = [
  {
    "alias": "items",
    "args": [
      (v1/*: any*/)
    ],
    "concreteType": "QueueItemConnection",
    "kind": "LinkedField",
    "name": "__helpersStyleArticleListQuery__items_connection",
    "plural": false,
    "selections": [
      (v2/*: any*/),
      {
        "kind": "InlineDataFragmentSpread",
        "name": "helpersIsPublishedWithin24HoursQueueItemConnection",
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "QueueItemsEdge",
            "kind": "LinkedField",
            "name": "edges",
            "plural": true,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": null,
                "kind": "LinkedField",
                "name": "node",
                "plural": false,
                "selections": [
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      (v3/*: any*/)
                    ],
                    "type": "Article",
                    "abstractKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "args": null,
        "argumentDefinitions": ([]/*: any*/)
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "QueueItemsEdge",
        "kind": "LinkedField",
        "name": "edges",
        "plural": true,
        "selections": [
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "storyCardLargeLayoutQueueItemsEdge"
          },
          {
            "alias": null,
            "args": null,
            "concreteType": null,
            "kind": "LinkedField",
            "name": "node",
            "plural": false,
            "selections": [
              {
                "kind": "InlineFragment",
                "selections": [
                  (v4/*: any*/),
                  {
                    "args": null,
                    "kind": "FragmentSpread",
                    "name": "storyCardItemArticle"
                  },
                  {
                    "args": null,
                    "kind": "FragmentSpread",
                    "name": "itemStoryCardCarouselWidgetDisplayItemArticle"
                  }
                ],
                "type": "Article",
                "abstractKey": null
              },
              (v2/*: any*/)
            ],
            "storageKey": null
          },
          (v5/*: any*/)
        ],
        "storageKey": null
      },
      (v6/*: any*/)
    ],
    "storageKey": "__helpersStyleArticleListQuery__items_connection(exclude:{\"types\":\"VIDEO\"})"
  }
],
v8 = [
  {
    "kind": "Literal",
    "name": "filter",
    "value": {
      "name": "section_top_516294"
    }
  }
],
v9 = [
  {
    "kind": "Literal",
    "name": "filter",
    "value": {
      "name": "section_top_516298"
    }
  }
],
v10 = [
  {
    "kind": "Literal",
    "name": "filter",
    "value": {
      "name": "section_top_516301"
    }
  }
],
v11 = [
  {
    "kind": "Literal",
    "name": "filter",
    "value": {
      "name": "section_top_516305"
    }
  }
],
v12 = [
  (v1/*: any*/),
  {
    "kind": "Literal",
    "name": "first",
    "value": 4
  }
],
v13 = [
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "url",
    "storageKey": null
  }
],
v14 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "entityUuid",
  "storageKey": null
},
v15 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v16 = [
  (v4/*: any*/),
  (v15/*: any*/)
],
v17 = [
  (v4/*: any*/)
],
v18 = {
  "kind": "InlineFragment",
  "selections": [
    (v15/*: any*/)
  ],
  "type": "Node",
  "abstractKey": "__isNode"
},
v19 = [
  (v2/*: any*/),
  {
    "alias": null,
    "args": null,
    "concreteType": "QueueItemsEdge",
    "kind": "LinkedField",
    "name": "edges",
    "plural": true,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": null,
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          {
            "kind": "InlineFragment",
            "selections": [
              (v3/*: any*/),
              {
                "alias": null,
                "args": [
                  {
                    "kind": "Literal",
                    "name": "filter",
                    "value": {
                      "type": {
                        "exclude": null
                      }
                    }
                  }
                ],
                "concreteType": "Image",
                "kind": "LinkedField",
                "name": "images",
                "plural": true,
                "selections": [
                  {
                    "alias": "wide_landscape",
                    "args": [
                      {
                        "kind": "Literal",
                        "name": "filter",
                        "value": {
                          "style": "wide_landscape"
                        }
                      }
                    ],
                    "concreteType": "ImageStyle",
                    "kind": "LinkedField",
                    "name": "style",
                    "plural": false,
                    "selections": (v13/*: any*/),
                    "storageKey": "style(filter:{\"style\":\"wide_landscape\"})"
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "alt",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "isSlideshow",
                    "storageKey": null
                  },
                  {
                    "alias": "url",
                    "args": [
                      {
                        "kind": "Literal",
                        "name": "filter",
                        "value": {
                          "style": "portrait"
                        }
                      }
                    ],
                    "concreteType": "ImageStyle",
                    "kind": "LinkedField",
                    "name": "style",
                    "plural": false,
                    "selections": (v13/*: any*/),
                    "storageKey": "style(filter:{\"style\":\"portrait\"})"
                  },
                  {
                    "alias": null,
                    "args": [
                      {
                        "kind": "Literal",
                        "name": "filter",
                        "value": {
                          "style": "134w_portrait"
                        }
                      }
                    ],
                    "concreteType": "ImageStyle",
                    "kind": "LinkedField",
                    "name": "style",
                    "plural": false,
                    "selections": (v13/*: any*/),
                    "storageKey": "style(filter:{\"style\":\"134w_portrait\"})"
                  }
                ],
                "storageKey": "images(filter:{\"type\":{\"exclude\":null}})"
              },
              (v4/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "socialHeadline",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "urlAlias",
                "storageKey": null
              },
              {
                "kind": "InlineFragment",
                "selections": [
                  (v14/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "UrlRedirect",
                    "kind": "LinkedField",
                    "name": "urlRedirect",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "toUrl",
                        "storageKey": null
                      },
                      (v15/*: any*/)
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Application",
                    "kind": "LinkedField",
                    "name": "application",
                    "plural": false,
                    "selections": (v16/*: any*/),
                    "storageKey": null
                  },
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "Section",
                        "kind": "LinkedField",
                        "name": "fullSectionPath",
                        "plural": true,
                        "selections": (v16/*: any*/),
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "parentSection",
                        "storageKey": null
                      }
                    ],
                    "type": "Section",
                    "abstractKey": null
                  },
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "flattenTypeIds",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "LiveArticle",
                        "kind": "LinkedField",
                        "name": "liveArticle",
                        "plural": false,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "status",
                            "storageKey": null
                          },
                          (v15/*: any*/)
                        ],
                        "storageKey": null
                      }
                    ],
                    "type": "Article",
                    "abstractKey": null
                  },
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "SectionSegmentV2",
                        "kind": "LinkedField",
                        "name": "sectionsV2",
                        "plural": true,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": null,
                            "kind": "LinkedField",
                            "name": "value",
                            "plural": true,
                            "selections": [
                              (v2/*: any*/),
                              {
                                "kind": "InlineFragment",
                                "selections": (v17/*: any*/),
                                "type": "Section",
                                "abstractKey": null
                              },
                              (v18/*: any*/),
                              {
                                "kind": "InlineFragment",
                                "selections": (v17/*: any*/),
                                "type": "VideoSection",
                                "abstractKey": null
                              }
                            ],
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      },
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "PaywallType",
                            "kind": "LinkedField",
                            "name": "paywallTypes",
                            "plural": true,
                            "selections": [
                              (v14/*: any*/),
                              (v15/*: any*/)
                            ],
                            "storageKey": null
                          }
                        ],
                        "type": "Article",
                        "abstractKey": null
                      }
                    ],
                    "type": "Content",
                    "abstractKey": "__isContent"
                  }
                ],
                "type": "BaseWithApplicationAndUrlAlias",
                "abstractKey": "__isBaseWithApplicationAndUrlAlias"
              }
            ],
            "type": "Article",
            "abstractKey": null
          },
          (v18/*: any*/)
        ],
        "storageKey": null
      },
      (v5/*: any*/)
    ],
    "storageKey": null
  },
  (v6/*: any*/)
],
v20 = [
  "exclude"
],
v21 = [
  (v1/*: any*/),
  {
    "kind": "Literal",
    "name": "first",
    "value": 8
  }
],
v22 = [
  {
    "alias": null,
    "args": (v21/*: any*/),
    "concreteType": "QueueItemConnection",
    "kind": "LinkedField",
    "name": "items",
    "plural": false,
    "selections": (v19/*: any*/),
    "storageKey": "items(exclude:{\"types\":\"VIDEO\"},first:8)"
  },
  {
    "alias": null,
    "args": (v21/*: any*/),
    "filters": (v20/*: any*/),
    "handle": "connection",
    "key": "helpersStyleArticleListQuery__items",
    "kind": "LinkedHandle",
    "name": "items"
  },
  (v15/*: any*/)
];
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "sectionStyleStoryCardCarouselWidgetQuery",
    "selections": [
      {
        "kind": "InlineDataFragmentSpread",
        "name": "displayStoryCardCarouselWidgetQuery",
        "selections": [
          {
            "kind": "InlineDataFragmentSpread",
            "name": "helpersStyleArticleListQuery",
            "selections": [
              {
                "alias": "luxury",
                "args": (v0/*: any*/),
                "concreteType": "Queue",
                "kind": "LinkedField",
                "name": "queue",
                "plural": false,
                "selections": (v7/*: any*/),
                "storageKey": "queue(filter:{\"entityId\":\"1070\"})"
              },
              {
                "alias": "fashion",
                "args": (v8/*: any*/),
                "concreteType": "Queue",
                "kind": "LinkedField",
                "name": "queue",
                "plural": false,
                "selections": (v7/*: any*/),
                "storageKey": "queue(filter:{\"name\":\"section_top_516294\"})"
              },
              {
                "alias": "beauty",
                "args": (v9/*: any*/),
                "concreteType": "Queue",
                "kind": "LinkedField",
                "name": "queue",
                "plural": false,
                "selections": (v7/*: any*/),
                "storageKey": "queue(filter:{\"name\":\"section_top_516298\"})"
              },
              {
                "alias": "people",
                "args": (v10/*: any*/),
                "concreteType": "Queue",
                "kind": "LinkedField",
                "name": "queue",
                "plural": false,
                "selections": (v7/*: any*/),
                "storageKey": "queue(filter:{\"name\":\"section_top_516301\"})"
              },
              {
                "alias": "lifestyle",
                "args": (v11/*: any*/),
                "concreteType": "Queue",
                "kind": "LinkedField",
                "name": "queue",
                "plural": false,
                "selections": (v7/*: any*/),
                "storageKey": "queue(filter:{\"name\":\"section_top_516305\"})"
              }
            ],
            "args": null,
            "argumentDefinitions": []
          }
        ],
        "args": null,
        "argumentDefinitions": []
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "sectionStyleStoryCardCarouselWidgetQuery",
    "selections": [
      {
        "alias": "luxury",
        "args": (v0/*: any*/),
        "concreteType": "Queue",
        "kind": "LinkedField",
        "name": "queue",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": (v12/*: any*/),
            "concreteType": "QueueItemConnection",
            "kind": "LinkedField",
            "name": "items",
            "plural": false,
            "selections": (v19/*: any*/),
            "storageKey": "items(exclude:{\"types\":\"VIDEO\"},first:4)"
          },
          {
            "alias": null,
            "args": (v12/*: any*/),
            "filters": (v20/*: any*/),
            "handle": "connection",
            "key": "helpersStyleArticleListQuery__items",
            "kind": "LinkedHandle",
            "name": "items"
          },
          (v15/*: any*/)
        ],
        "storageKey": "queue(filter:{\"entityId\":\"1070\"})"
      },
      {
        "alias": "fashion",
        "args": (v8/*: any*/),
        "concreteType": "Queue",
        "kind": "LinkedField",
        "name": "queue",
        "plural": false,
        "selections": (v22/*: any*/),
        "storageKey": "queue(filter:{\"name\":\"section_top_516294\"})"
      },
      {
        "alias": "beauty",
        "args": (v9/*: any*/),
        "concreteType": "Queue",
        "kind": "LinkedField",
        "name": "queue",
        "plural": false,
        "selections": (v22/*: any*/),
        "storageKey": "queue(filter:{\"name\":\"section_top_516298\"})"
      },
      {
        "alias": "people",
        "args": (v10/*: any*/),
        "concreteType": "Queue",
        "kind": "LinkedField",
        "name": "queue",
        "plural": false,
        "selections": (v22/*: any*/),
        "storageKey": "queue(filter:{\"name\":\"section_top_516301\"})"
      },
      {
        "alias": "lifestyle",
        "args": (v11/*: any*/),
        "concreteType": "Queue",
        "kind": "LinkedField",
        "name": "queue",
        "plural": false,
        "selections": (v22/*: any*/),
        "storageKey": "queue(filter:{\"name\":\"section_top_516305\"})"
      }
    ]
  },
  "params": {
    "cacheID": "1e058ae77560223b38ef1bff26d55973",
    "id": null,
    "metadata": {},
    "name": "sectionStyleStoryCardCarouselWidgetQuery",
    "operationKind": "query",
    "text": "query sectionStyleStoryCardCarouselWidgetQuery {\n  ...displayStoryCardCarouselWidgetQuery\n}\n\nfragment displayStoryCardCarouselWidgetQuery on Query {\n  ...helpersStyleArticleListQuery\n}\n\nfragment entityLink on BaseWithApplicationAndUrlAlias {\n  __isBaseWithApplicationAndUrlAlias: __typename\n  __typename\n  entityId\n  entityUuid\n  urlAlias\n  urlRedirect {\n    toUrl\n    id\n  }\n  application {\n    entityId\n    id\n  }\n  ... on Section {\n    fullSectionPath {\n      entityId\n      id\n    }\n    parentSection\n  }\n  ...helpersAppBarVariantBase\n  ...helpersApplicationBase\n  ...helpersCheckIsPlusArticle\n  ...helpersStyleSectionContent\n}\n\nfragment helpersAppBarVariantBase on BaseWithApplicationAndUrlAlias {\n  __isBaseWithApplicationAndUrlAlias: __typename\n  ...helpersCheckIsLiveArticle\n  ...helpersCheckIsPlusPage\n  ...helpersCheckIsPostMagazineArticle\n  ...helpersCheckIsStyleArticle\n  ...helpersSectionContent\n  ...helpersStyleSectionContent\n}\n\nfragment helpersApplicationBase on BaseWithApplicationAndUrlAlias {\n  __isBaseWithApplicationAndUrlAlias: __typename\n  ...helpersCheckIsPlusPage\n}\n\nfragment helpersCheckIsLiveArticle on Article {\n  flattenTypeIds\n  liveArticle {\n    status\n    id\n  }\n}\n\nfragment helpersCheckIsPlusArticle on Content {\n  __isContent: __typename\n  ... on Article {\n    paywallTypes {\n      entityUuid\n      id\n    }\n  }\n}\n\nfragment helpersCheckIsPlusPage on Page {\n  urlAlias\n}\n\nfragment helpersCheckIsPostMagazineArticle on Content {\n  __isContent: __typename\n  sectionsV2 {\n    value {\n      __typename\n      ... on Section {\n        entityId\n      }\n      ... on Node {\n        __isNode: __typename\n        id\n      }\n    }\n  }\n}\n\nfragment helpersCheckIsStyleArticle on Content {\n  __isContent: __typename\n  sectionsV2 {\n    value {\n      __typename\n      ... on Section {\n        entityId\n      }\n      ... on VideoSection {\n        entityId\n      }\n      ... on Node {\n        __isNode: __typename\n        id\n      }\n    }\n  }\n}\n\nfragment helpersIsPublishedWithin24HoursQueueItemConnection on QueueItemConnection {\n  edges {\n    node {\n      __typename\n      ... on Article {\n        publishedDate\n      }\n      ... on Node {\n        __isNode: __typename\n        id\n      }\n    }\n  }\n}\n\nfragment helpersSectionContent on Section {\n  fullSectionPath {\n    entityId\n    id\n  }\n}\n\nfragment helpersStyleArticleListQuery on Query {\n  luxury: queue(filter: {entityId: \"1070\"}) {\n    items(first: 4, exclude: {types: VIDEO}) {\n      __typename\n      ...helpersIsPublishedWithin24HoursQueueItemConnection\n      edges {\n        ...storyCardLargeLayoutQueueItemsEdge\n        node {\n          __typename\n          ... on Article {\n            entityId\n            ...storyCardItemArticle\n            ...itemStoryCardCarouselWidgetDisplayItemArticle\n          }\n          ... on Node {\n            __isNode: __typename\n            id\n          }\n        }\n        cursor\n      }\n      pageInfo {\n        endCursor\n        hasNextPage\n      }\n    }\n    id\n  }\n  fashion: queue(filter: {name: \"section_top_516294\"}) {\n    items(first: 8, exclude: {types: VIDEO}) {\n      __typename\n      ...helpersIsPublishedWithin24HoursQueueItemConnection\n      edges {\n        ...storyCardLargeLayoutQueueItemsEdge\n        node {\n          __typename\n          ... on Article {\n            entityId\n            ...storyCardItemArticle\n            ...itemStoryCardCarouselWidgetDisplayItemArticle\n          }\n          ... on Node {\n            __isNode: __typename\n            id\n          }\n        }\n        cursor\n      }\n      pageInfo {\n        endCursor\n        hasNextPage\n      }\n    }\n    id\n  }\n  beauty: queue(filter: {name: \"section_top_516298\"}) {\n    items(first: 8, exclude: {types: VIDEO}) {\n      __typename\n      ...helpersIsPublishedWithin24HoursQueueItemConnection\n      edges {\n        ...storyCardLargeLayoutQueueItemsEdge\n        node {\n          __typename\n          ... on Article {\n            entityId\n            ...storyCardItemArticle\n            ...itemStoryCardCarouselWidgetDisplayItemArticle\n          }\n          ... on Node {\n            __isNode: __typename\n            id\n          }\n        }\n        cursor\n      }\n      pageInfo {\n        endCursor\n        hasNextPage\n      }\n    }\n    id\n  }\n  people: queue(filter: {name: \"section_top_516301\"}) {\n    items(first: 8, exclude: {types: VIDEO}) {\n      __typename\n      ...helpersIsPublishedWithin24HoursQueueItemConnection\n      edges {\n        ...storyCardLargeLayoutQueueItemsEdge\n        node {\n          __typename\n          ... on Article {\n            entityId\n            ...storyCardItemArticle\n            ...itemStoryCardCarouselWidgetDisplayItemArticle\n          }\n          ... on Node {\n            __isNode: __typename\n            id\n          }\n        }\n        cursor\n      }\n      pageInfo {\n        endCursor\n        hasNextPage\n      }\n    }\n    id\n  }\n  lifestyle: queue(filter: {name: \"section_top_516305\"}) {\n    items(first: 8, exclude: {types: VIDEO}) {\n      __typename\n      ...helpersIsPublishedWithin24HoursQueueItemConnection\n      edges {\n        ...storyCardLargeLayoutQueueItemsEdge\n        node {\n          __typename\n          ... on Article {\n            entityId\n            ...storyCardItemArticle\n            ...itemStoryCardCarouselWidgetDisplayItemArticle\n          }\n          ... on Node {\n            __isNode: __typename\n            id\n          }\n        }\n        cursor\n      }\n      pageInfo {\n        endCursor\n        hasNextPage\n      }\n    }\n    id\n  }\n}\n\nfragment helpersStyleSectionContent on Section {\n  fullSectionPath {\n    entityId\n    id\n  }\n}\n\nfragment imageStoryStyleCardImageArticle on Article {\n  images(filter: {type: {exclude: null}}) {\n    alt\n    isSlideshow\n    url: style(filter: {style: \"portrait\"}) {\n      url\n    }\n  }\n}\n\nfragment itemStoryCardCarouselWidgetDisplayItemArticle on Article {\n  images(filter: {type: {exclude: null}}) {\n    alt\n    isSlideshow\n    style(filter: {style: \"134w_portrait\"}) {\n      url\n    }\n  }\n  ...entityLink\n}\n\nfragment linkStoryStyleCardLinkArticle on Article {\n  ...entityLink\n  urlAlias\n}\n\nfragment storyCardItemArticle on Article {\n  ...imageStoryStyleCardImageArticle\n  ...titleStoryStyleCardTitleArticle\n  ...linkStoryStyleCardLinkArticle\n}\n\nfragment storyCardLargeLayoutQueueItemsEdge on QueueItemsEdge {\n  node {\n    __typename\n    ... on Article {\n      images(filter: {type: {exclude: null}}) {\n        wide_landscape: style(filter: {style: \"wide_landscape\"}) {\n          url\n        }\n      }\n    }\n    ... on Node {\n      __isNode: __typename\n      id\n    }\n  }\n}\n\nfragment titleStoryStyleCardTitleArticle on Article {\n  socialHeadline\n}\n"
  }
};
})();

(node as any).hash = "c775783fe725007630d4a5074007f961";

export default node;
